import type { RiskIndicator } from '../types';
import { SearchCheck } from '../../../../common/icons/lucide-adapter';
import { ReportWrapper } from '../../report-shared/components';
import { ContentFindings } from '../components/ContentFindings';

type ContentFindingsSectionProps = {
  contentRiskIndicators?: RiskIndicator[] | null;
};

export const ContentFindingsSection = ({ contentRiskIndicators }: ContentFindingsSectionProps) => {
  return (
    <ReportWrapper
      title="Content Findings"
      Icon={SearchCheck}
      tooltip="Analysis of website content for potential risk indicators and compliance issues."
      showTooltip={false}
    >
      <ContentFindings riskIndicators={contentRiskIndicators ?? []} />
    </ReportWrapper>
  );
};
